import { render } from "./app-form-switch.vue?vue&type=template&id=6f8936a1"
import script from "./app-form-switch.vue?vue&type=script&lang=js"
export * from "./app-form-switch.vue?vue&type=script&lang=js"

import "./app-form-switch.vue?vue&type=style&index=0&id=6f8936a1&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__